import { useEffect, useMemo, useState } from "react";

import { formatWeekEndDate } from "./weeklyEACCalculations";
import { getWeekScrollOffset } from "./weeklyEACWeekNavigation";

// Drives the "Go to Week" selector: no week is selected by default and every scrollable table
// (Direct Labor, Other Direct Costs, Summary) starts scrolled to its first column, and the user
// can jump to any week on demand. All of them move together since they share the same offset math
// (see weeklyEACWeekNavigation.getWeekScrollOffset).
export const useWeeklyEACWeekNavigation = ({
  directLaborData,
  computedWeeklyTotals,
  type,
  scrollRefs,
}) => {
  const [selectedWeekStartDate, setSelectedWeekStartDate] = useState("");

  // A new CLIN/version fetch clears the selection and resets every table to its start — the
  // scroll containers are the same DOM nodes across data changes, so scrollLeft doesn't reset on
  // its own.
  useEffect(() => {
    setSelectedWeekStartDate("");
    scrollRefs.forEach((ref) => {
      if (ref.current) ref.current.scrollLeft = 0;
    });
  }, [directLaborData]);

  const scrollToWeek = (weekStartDate, weeks) => {
    const offset = getWeekScrollOffset(weekStartDate, weeks, type);
    if (offset === null) return;
    scrollRefs.forEach((ref) => {
      if (ref.current) ref.current.scrollLeft = offset;
    });
  };

  const weekOptions = useMemo(
    () =>
      computedWeeklyTotals.map((week) => ({
        value: week.weekStartDate,
        label: `${formatWeekEndDate(week.weekStartDate)} - ${formatWeekEndDate(week.weekEndDate)} (${week.type})`,
      })),
    [computedWeeklyTotals],
  );

  const handleWeekSelect = (weekStartDate) => {
    setSelectedWeekStartDate(weekStartDate);
    scrollToWeek(weekStartDate, computedWeeklyTotals);
  };

  return { selectedWeekStartDate, weekOptions, handleWeekSelect };
};
